import VerificationsIdentity from '__core/shared/model/tool/VerificationsIdentity';
import {
  isThereAnyContactWhoIsCompanyOrSelfEmployed,
  areAllContactsCompanies
} from '__core/shared/util/salestrekker';

/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $timeout,
  $location,
  $anchorScroll,
  webpage,
  cookies,
  authenticationService,
  jsonFactory,
  eventService,
  helperService,
  lendersService,
  accountService,
  Contact,
  contactService,
  contactsService,
  expensesService,
  incomeService,
  Asset,
  Ownership,
  assetsService,
  Liability,
  liabilitiesService,
  Insurance,
  insurancesService,
  otherAdvisersService,
  ticketService,
  ticketsService,
  TicketStatusHistory,
  workflowService,
  labelsService,
  RiskInsurance,
  RiskInsuranceRequirementsApplicant,
  RiskInsuranceCompliance,
  riskInsuranceService,
  documentsService,
  notesService,
  uiService,
  openBankingService
) => {
  $scope.Model = {
    hasBrokerToolsEnabled: $rootScope.hasBrokerToolsEnabled(),
    organizationCountry: helperService.getOrganizationCountry(),
    countries: [],
    currentTicket: {},
    currentWorkflow: {},
    currentTicketOwner: {},
    currentRiskInsurance: {},
    availableContacts: [],
    availablePersonContacts: [],
    availableSpouses: [],
    availableLabels: [],
    availableLendersPerCountry: [],
    availableIncomeTypes: incomeService.getAvailableIncomeTypes(),
    availableAssetTypes: assetsService.getAvailableAssetTypes(),
    availableLiabilityTypes: [],
    availableInsuranceTypes: [],
    availableOtherAdviserTypes: [],
    availableRiskInsuranceProductTypes:
      riskInsuranceService.getAvailableRiskInsuranceProductTypes(),
    activeSection: 'applicant0',
    availableSections: [],
    factFindSections: [
      'income',
      'expenses',
      'assets',
      'liabilities',
      'insurance',
      'otherAdvisers'
    ],
    riskInsuranceSections: [
      'requirements',
      'products',
      'compliance',
      'diversificationOpportunities'
    ],
    isSidebarMinimized: cookies.get('stSidebar') || false,
    availableAddresses: [],
    openBankingData: [],
    openBankingContacts: [],
    isDealOwnerBroker: true,
    isReady: false
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  const loadLendersPerCountry = () => {
    const deferred = $q.defer();
    lendersService
      .getAvailable({
        cca2: [$scope.Model.organizationCountry?.cca2]
      })
      .then((lenders) => {
        if (lenders?.length) {
          $scope.Model.availableLendersPerCountry = lenders;
        }
        deferred.resolve(lenders);
      });
    return deferred.promise;
  };

  const loadLabels = () => {
    labelsService
      .getAvailable({
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        $scope.Model.availableLabels = labels;
        $scope.Model.availableFileLabels = labels.filter(
          (l) => l.type === 'file' && l.isLocked
        );
        $scope.Model.availableContactLabels = labels.filter((l) => l.type === 'contact');
      });
  };

  const loadWorkflow = () => {
    workflowService.readWorkflow({ id: $stateParams.id }).then((workflow) => {
      $scope.Model.currentWorkflow = workflow;
    });
  };

  const loadTicket = (idTicket) => {
    const deferred = $q.defer();
    ticketService.readTicket({ id: idTicket }).then((ticket) => {
      $scope.Model.currentTicket = ticket;
      deferred.resolve(ticket);
    });
    return deferred.promise;
  };

  const loadAccount = (idOwner) => {
    const deferred = $q.defer();
    accountService.readAccount({ id: idOwner }).then((account) => {
      $scope.Model.currentTicketOwner = account;
      deferred.resolve(account);
    });
    return deferred.promise;
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    contactsService.getSpecific({ idContacts, isActive: true }).then((contacts) => {
      $scope.Model.availableContacts = _.compact(
        _.sortBy(contacts, (c) => _.indexOf($scope.Model.currentTicket?.idClients || [], c?.id))
      );
      $scope.Model.availablePersonContacts = _.filter(
        $scope.Model.availableContacts || [],
        (c) => !c.isCompany
      );
      deferred.resolve(contacts);
    });
    return deferred.promise;
  };

  const loadSpouses = (idContacts) => {
    contactsService.getSpecific({ idContacts, isActive: true }).then((spouses) => {
      $scope.Model.availableSpouses = spouses;
    });
  };

  const loadRiskInsurance = (idRiskInsurance) => {
    const deferred = $q.defer();
    riskInsuranceService.readRiskInsurance({ id: idRiskInsurance }).then((riskInsurance) => {
      $scope.Model.currentRiskInsurance = riskInsurance;
      deferred.resolve(riskInsurance);
    });
    return deferred.promise;
  };

  const loadDocuments = () => {
    documentsService.getAvailable({ isActive: true }).then((documents) => {
      $scope.Model.availableDocuments = documents;
    });
  };

  const loadNotes = () => {
    const deferred = $q.defer();
    notesService
      .getSpecific({ idTickets: $scope.Model.currentTicket.id, isActive: true })
      .then((notes) => {
        $scope.Model.availableNotes = notes;
        deferred.resolve(notes);
      });
    return deferred.promise;
  };

  const loadAttachments = (notes) => {
    $timeout(() => {
      let noteAttachments = _.map(notes || [], (note) => {
        const attachments = [];
        for (let n = 0; n < note?.attachments?.length; n += 1) {
          const attach = note.attachments[n];
          attach.idNote = note?.id;
          attach.noteType = note?.type;
          if (_.find(attachments, { id: attach?.id }) === undefined) {
            attachments.push(attach);
          }
        }
        return attachments;
      });
      noteAttachments = _.flatten(noteAttachments);
      $scope.Model.attachmentsFiles = _.union(
        $scope.Model.currentTicket.attachments,
        noteAttachments
      );
      $scope.Model.attachmentsCompliance = _.filter(
        $scope.Model.attachmentsFiles || [],
        (a) => (a.noteType?.name !== 'video') !== undefined
      );
      $scope.Model.attachmentsFiles = _.filter(
        $scope.Model.attachmentsFiles || [],
        (a) => a.noteType?.name !== 'video'
      );
    });
  };

  const loadOpenBanking = () => {
    const deferred = $q.defer();
    if (
      $rootScope.isDev() &&
      $scope.Model.currentTicket?.openBanking?.length &&
      $scope.Model.currentTicket?.sharedWith?.clientProfile?.length
    ) {
      const idTicket = $scope.Model.currentTicket?.id;
      const idContacts = [];
      const len = $scope.Model.currentTicket?.sharedWith?.clientProfile?.length || 0;
      for (let c = 0; c < len; c += 1) {
        const clientProfile = $scope.Model.currentTicket?.sharedWith?.clientProfile[c];
        const openBanking = _.find(
          $scope.Model.currentTicket?.openBanking || [],
          (o) => o?.idContact === clientProfile?.idClient && o?.isFinished && o?.hasData
        );
        if (
          clientProfile?.integrations?.isOpenBankingEnabled &&
          _.indexOf(
            $scope.Model.currentTicket?.sharedWith?.idClientsWithAccess || [],
            clientProfile?.idClient
          ) > -1 &&
          openBanking
        ) {
          idContacts.push(clientProfile?.idClient);
        }
      }
      deferred.resolve([]);
    } else {
      deferred.resolve([]);
    }
    return deferred.promise;
  };

  const initialize = () => {
    loadLendersPerCountry();
    loadLabels();
    loadWorkflow();
    $q.all([
      jsonFactory.getCountries(),
      jsonFactory.getOccupations(),
      jsonFactory.getIndustries()
    ]).then((res) => {
      const countries = res[0];
      const occupations = res[1];
      const industries = res[2];
      $scope.Model.countries = countries;
      $scope.Model.occupations = occupations;
      $scope.Model.industries = industries;

      loadTicket($stateParams.dd).then(() => {
        webpage.pageTitle($scope.Model.currentTicket.getName());
        $scope.getLiabilityTypes();
        $scope.getInsuranceTypes();
        $scope.getOtherAdviserTypes();

        loadContacts($scope.Model.currentTicket.idClients).then(() => {
          loadOpenBanking().then(() => {
            for (let c = 0; c < $scope.Model.availableContacts.length; c += 1) {
              $scope.Model.availableSections.push(`applicant${c}`);
            }

            if (!$scope.showIncome()) {
              const idx = $scope.Model.factFindSections.indexOf('income');
              $scope.Model.factFindSections.splice(idx, 1);
            }
            if (!$scope.showExpenses()) {
              const idx = $scope.Model.factFindSections.indexOf('expenses');
              $scope.Model.factFindSections.splice(idx, 1);
            }
            if (!$scope.showObjectivesInsurancesAndOtherAdvisers()) {
              const iIdx = $scope.Model.factFindSections.indexOf('insurance');
              $scope.Model.factFindSections.splice(iIdx, 1);
              const oAIdx = $scope.Model.factFindSections.indexOf('otherAdvisers');
              $scope.Model.factFindSections.splice(oAIdx, 1);
            }

            let idSpouses = _.map(
              _.filter(
                $scope.Model.availablePersonContacts,
                (c) => c.person.information.idSpouse && c.person.information.idSpouse !== ''
              ),
              (s) => s.person.information.idSpouse
            );
            idSpouses = _.uniq(_.compact(idSpouses));

            if (idSpouses.length) {
              loadSpouses(idSpouses);
            }

            for (let a = 0; a < $scope.Model.currentTicket.assets.length; a += 1) {
              if (!$scope.Model.currentTicket.assets[a].ownership.length) {
                $scope.Model.currentTicket.assets[a].ownership =
                  helperService.setOwnershipOfAssetOrLiability(
                    $scope.Model.availableContacts,
                    false
                  );
              }
            }
            for (let l = 0; l < $scope.Model.currentTicket.liabilities.length; l += 1) {
              if (!$scope.Model.currentTicket.liabilities[l].ownership.length) {
                $scope.Model.currentTicket.liabilities[l].ownership =
                  helperService.setOwnershipOfAssetOrLiability(
                    $scope.Model.availableContacts,
                    false
                  );
              }
            }

            $scope.Model.availableSections = $scope.Model.availableSections.concat(
              $scope.Model.factFindSections
            );
            loadAccount($scope.Model.currentTicket.idOwner).then(() => {
              if ($scope.hasRiskInsuranceTools()) {
                $scope.Model.availableSections = $scope.Model.availableSections.concat(
                  $scope.Model.riskInsuranceSections
                );
                if (!$scope.Model.currentTicket.idRiskInsurance) {
                  $scope.Model.currentRiskInsurance = RiskInsurance.blank();
                  $scope.Model.currentRiskInsurance.idTicket = $scope.Model.currentTicket.id;
                  $scope.Model.currentRiskInsurance.idOwner =
                    $scope.Model.currentTicket.idOwner;
                  $scope.updateSectionsOfApplicants();
                  $scope.getAllAddresses();
                  $scope.Model.isReady = true;
                } else {
                  loadRiskInsurance($scope.Model.currentTicket.idRiskInsurance).then(() => {
                    loadDocuments();
                    $scope.updateSectionsOfApplicants();
                    loadNotes().then(() => {
                      loadAttachments($scope.Model.availableNotes);
                      $timeout(() => {
                        $scope.getAllAddresses();
                        $scope.Model.isReady = true;
                      });
                    });
                  });
                }
              } else {
                $state.transitionTo('factFind', {
                  id: $stateParams.id,
                  dd: $stateParams.dd
                });
              }
            });
          });
        });
      });
    });
  };

  initialize();

  /*
   * Risk insurance ~ Switch UI Section
   * --------------------------------------------------------------------------------
   */
  $scope.showSection = (section) => {
    const previousSection = $scope.Model.activeSection.slice();
    $scope.Model.activeSection = section;

    if ($scope.Model.activeSection === 'lodgement') {
      if ($scope.hasDriveOnlineAnyErrors()) {
        $scope.showDriveOnlineErrors();
        $scope.Model.activeSection = previousSection;
      }
    }
  };

  $scope.getNumberOfSection = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    return idx + 1;
  };

  $scope.previous = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    $scope.Model.activeSection =
      section !== 'applicant0' ? $scope.Model.availableSections[idx - 1] : section;
    $scope.showSection($scope.Model.activeSection);
    $location.hash('top');
    $anchorScroll();
  };

  $scope.next = (section) => {
    const idx = $scope.Model.availableSections.indexOf(section);
    $scope.Model.activeSection =
      $scope.Model.availableSections[idx + 1] !== undefined
        ? $scope.Model.availableSections[idx + 1]
        : $scope.Model.availableSections[idx];
    $scope.showSection($scope.Model.activeSection);
    $location.hash('top');
    $anchorScroll();
  };

  $scope.isNextDisabled = () => {
    const idx = $scope.Model.availableSections.indexOf($scope.Model.activeSection);

    if ($scope.Model.availableSections[idx + 1] === 'gateway' && !$scope.isLodgementEnabled()) {
      return true;
    }
    return $scope.Model.availableSections[idx + 1] === undefined;
  };

  /*
   * Risk insurance ~ Helpers
   * --------------------------------------------------------------------------------
   */
  $scope.hasRiskInsuranceTools = () =>
    $scope.Model.currentWorkflow.isRiskInsurance() && $rootScope.canSeeRiskInsuranceTools();

  $scope.isDealOwnerMentee = () =>
    $rootScope.CurrentOrganization.mentees &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner] !== undefined &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner].length > 0;

  $scope.isDealOwnerHasMentor = () =>
    $rootScope.CurrentOrganization.mentees &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner] &&
    $rootScope.CurrentOrganization.mentees[$scope.Model.currentTicket.idOwner].indexOf(
      $rootScope.CurrentAccount.id
    ) > -1 &&
    authenticationService.isBroker($rootScope.CurrentAccount.id);

  $scope.showRiskInsuranceTools = () =>
    $scope.Model.isReady &&
    $rootScope.canSeeRiskInsuranceTools() &&
    $scope.Model.currentWorkflow?.isRiskInsurance();

  $scope.setCaretClass = (isView) =>
    `${ticketService.setCaretClass(isView)} ${
      $scope.Model.isSidebarMinimized || !$rootScope.IsMedia('gt-sm') ? 'hide' : ''
    }`;

  $scope.toggleSidebar = () => {
    $scope.Model.isSidebarMinimized = !$scope.Model.isSidebarMinimized;
    if ($scope.Model.isSidebarMinimized) {
      cookies.set('stSidebar', btoa('sidebar is minimized'), {
        path: '/'
      });
    } else {
      cookies.remove('stSidebar', { path: '/' });
    }
  };

  $scope.areAllClientsNonBorrowingSpouse = () =>
    $scope.Model.availableNonBorrowingSpouses?.length ===
      $scope.Model.availablePersonContacts?.length &&
    $scope.Model.availablePersonContacts?.length === $scope.Model.availableContacts?.length;

  $scope.areAllClientsSecurityGuarantor = () =>
    $scope.Model.availableSecurityGuarantors?.length ===
      $scope.Model.availablePersonContacts?.length &&
    $scope.Model.availablePersonContacts?.length === $scope.Model.availableContacts?.length;

  $scope.areAllClientsCompanyAndSecurityGuarantor = () => {
    const clients = $scope.Model.availableCompanyOnlyContacts.concat(
      $scope.Model.availableSecurityGuarantors
    );
    return clients?.length === $scope.Model.availableContacts?.length;
  };

  $scope.areAllClientsServicingGuarantor = () =>
    $scope.Model.availableServicingGuarantors?.length ===
      $scope.Model.availablePersonContacts?.length &&
    $scope.Model.availablePersonContacts?.length === $scope.Model.availableContacts?.length;

  $scope.allContactsAreCompanies = () =>
    _.every($scope.Model.availableContacts, (c) => c.isCompany);

  $scope.showIncome = () =>
    ($scope.Model.availablePersonContacts.length > 0 &&
      !$scope.areAllClientsSecurityGuarantor()) ||
    ($scope.Model.availablePersonContacts.length &&
      $scope.Model.availableContacts.length === 1 &&
      !helperService.isClientSecurityGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonContacts[0].id
      })) ||
    $scope.allContactsAreCompanies();

  $scope.showExpenses = () => !$scope.allContactsAreCompanies();

  $scope.showObjectivesInsurancesAndOtherAdvisers = () =>
    ($scope.Model.availablePersonContacts.length > 0 &&
      !$scope.areAllClientsSecurityGuarantor() &&
      !$scope.areAllClientsServicingGuarantor()) ||
    ($scope.Model.availablePersonContacts.length &&
      $scope.Model.availableContacts.length === 1 &&
      !helperService.isClientSecurityGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonContacts[0].id
      }) &&
      !helperService.isClientServicingGuarantor({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonContacts[0].id
      }) &&
      !helperService.isClientNonBorrowingSpouse({
        ticketClientTypes: $scope.Model.currentTicket.ticketClientTypes,
        idContact: $scope.Model.availablePersonContacts[0].id
      })) ||
    $scope.allContactsAreCompanies();

  $scope.getLabel = (idLabel) =>
    _.find($scope.Model.availableFileLabels, (l) => l.id === idLabel);

  $scope.isThereAnyContactWhoIsCompanyOrSelfEmployed = () =>
    isThereAnyContactWhoIsCompanyOrSelfEmployed($scope.Model.availableContacts);

  $scope.areAllContactsCompanies = () =>
    areAllContactsCompanies($scope.Model.availableContacts);

  $scope.getContact = (idContact) =>
    $scope.Model.availableContacts.find((c) => c.id === idContact);

  $scope.getAllAddresses = () => {
    $scope.Model.availableAddresses = helperService.getAllAddresses(
      $scope.Model.availableContacts,
      $scope.Model.currentTicket.assets,
      $scope.Model.currentTicket.otherAdvisers,
      $scope.Model.currentTicketOwner,
      $scope.Model.currentWorkflow,
      false,
      null,
      null,
      null,
      $scope.Model.currentRiskInsurance
    );
  };

  /*
   * Risk insurance ~ Income
   * --------------------------------------------------------------------------------
   */
  $scope.incomeAdd = (incomeType, idContact, idEmployer) => {
    incomeService.incomeAdd(
      $scope.Model.currentTicket.income,
      incomeType,
      idContact,
      idEmployer
    );
    if (idContact && idEmployer) {
      $scope.saveIncome({ income: $scope.Model.currentTicket.income });
    }
  };

  $scope.saveIncome = (data) => {
    $scope.saveTicket({ income: data?.income || [], tCD: data?.tCD || '' });
  };

  /*
   * Risk insurance ~ Expenses
   * --------------------------------------------------------------------------------
   */
  $scope.saveExpenses = (data) => {
    $scope.saveTicket({ expenses: data?.expenses || [], tCD: data?.tCD || '' });
  };

  /*
   * Risk insurance ~ Assets
   * --------------------------------------------------------------------------------
   */
  $scope.assetAdd = (assetType) => {
    assetsService.assetAdd(
      $scope.Model.currentTicket.assets,
      assetType,
      $scope.Model.availableContacts
    );
  };

  $scope.contactsHaveAssets = () =>
    _.some($scope.Model.availableContacts, (c) => c.assets.length);

  $scope.addContactAssets = (data) => {
    if (data instanceof Asset) {
      const asset = data;
      $scope.addContactAsset(asset);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let a = 0; a < contact.assets.length; a += 1) {
        const asset = contact.assets[a];
        $scope.addContactAsset(asset);
      }
    }
  };

  $scope.addContactAsset = (assetToAdd) => {
    const asset = assetToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      const idx = helperService.findIndexByContactId(
        asset.ownership,
        $scope.Model.availableContacts[i].id
      );
      if (idx === -1) {
        asset.ownership.push(Ownership.blank($scope.Model.availableContacts[i].id, 0));
      }
    }
    const idAssets = _.uniq(_.map($scope.Model.currentTicket.assets, 'id'));
    if (idAssets.indexOf(asset.idReference) === -1) {
      asset.idReference = asset.id;
      $scope.Model.currentTicket.assets.push(Asset.build(asset));
      contactsService.clearCache($scope.Model.currentTicket.assets);
      $scope.saveAssets({ assets: $scope.Model.currentTicket.assets, tCD: 'assets' });
    } else {
      uiService.toast({
        text: {
          p1: 'Asset',
          p2: asset.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.saveAssets = (data) => {
    $scope.saveTicket({ assets: data?.assets || [], tCD: data?.tCD || '' });
  };

  /*
   * Risk insurance ~ Liabilities
   * --------------------------------------------------------------------------------
   */
  $scope.getLiabilityTypes = () => {
    $scope.Model.availableLiabilityTypes = liabilitiesService.getLiabilityTypes(
      $scope.Model.currentTicket.assets
    );
  };

  $scope.liabilityAdd = (liabilityType) => {
    liabilitiesService.liabilityAdd(
      $scope.Model.currentTicket.liabilities,
      liabilityType,
      $scope.Model.availableContacts
    );
    $scope.validate();
  };

  $scope.contactsHaveLiabilities = () =>
    _.some($scope.Model.availableContacts, (c) => c.liabilities.length);

  $scope.addContactLiabilities = (data) => {
    if (data instanceof Liability) {
      const liability = data;
      $scope.addContactLiability(liability);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let l = 0; l < contact.liabilities.length; l += 1) {
        const liability = contact.liabilities[l];
        $scope.addContactLiability(liability);
      }
    }
  };

  $scope.addContactLiability = (liabilityToAdd) => {
    const liability = liabilityToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      const idx = helperService.findIndexByContactId(
        liability.ownership,
        $scope.Model.availableContacts[i].id
      );
      if (idx === -1) {
        liability.ownership.push(Ownership.blank($scope.Model.availableContacts[i].id, 0));
      }
    }
    const idLiabilities = _.uniq(_.map($scope.Model.currentTicket.liabilities, 'id'));
    if (idLiabilities.indexOf(liability.idReference) === -1) {
      liability.idReference = liability.id;
      $scope.Model.currentTicket.liabilities.push(Liability.build(liability));
      contactsService.clearCache();
      $scope.saveLiabilities({
        liabilities: $scope.Model.currentTicket.liabilities,
        tCD: 'liabilities'
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Liability',
          p2: liability.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.saveLiabilities = (data) => {
    $scope.saveTicket({
      liabilities: data?.liabilities || [],
      tCD: data?.tCD || ''
    });
  };

  /*
   * Risk insurance ~ Open banking
   * --------------------------------------------------------------------------------
   */
  $scope.showOpenBankingData = (event, type) => {
    eventService.dialogOpenBanking({
      event,
      contacts: $scope.Model.openBankingContacts || [],
      openBankingData: $scope.Model.openBankingData || [],
      openBankingDataType: type,
      ticket: $scope.Model.currentTicket
    });
  };

  $scope.hasData = (type) => _.some($scope.Model.openBankingData || [], (o) => o[type]?.length);

  $scope.openBankingFinished = (data) => {
    if (data?.type && data?.selectedData?.length) {
      const updatedData = helperService.processOpenBankingData({
        data,
        ticket: $scope.Model.currentTicket,
        contacts: $scope.Model.availableContacts
      });
      if (updatedData) {
        $scope.Model.currentTicket[data?.type] = updatedData;
        $scope.saveTicket({
          [data?.type]: $scope.Model.currentTicket[data?.type],
          tCD: data?.type
        });
      }
    }
  };

  /*
   * Risk insurance ~ Insurance
   * --------------------------------------------------------------------------------
   */
  $scope.getInsuranceTypes = () => {
    $scope.Model.availableInsuranceTypes = insurancesService.getInsuranceTypes({
      assets: $scope.Model.currentTicket.assets
    });
  };

  $scope.canSeeInsuranceType = (insuranceType) =>
    insurancesService.canSeeInsuranceType(insuranceType);

  $scope.insuranceAdd = (insuranceType) => {
    insurancesService.insuranceAdd($scope.Model.currentTicket.insurances, insuranceType);
  };

  $scope.contactsHaveInsurance = () =>
    _.some($scope.Model.availableContacts, (c) => c.insurances.length);

  $scope.addContactInsurances = (data) => {
    if (data instanceof Insurance) {
      const insurance = data;
      $scope.addContactInsurance(insurance);
    }
    if (data instanceof Contact) {
      const contact = data;
      for (let i = 0; i < contact.insurances.length; i += 1) {
        const insurance = contact.insurances[i];
        $scope.addContactInsurance(insurance);
      }
    }
  };

  $scope.addContactInsurance = (insuranceToAdd) => {
    const insurance = insuranceToAdd;
    for (let i = 0; i < $scope.Model.availableContacts.length; i += 1) {
      if (insurance.idContacts.indexOf($scope.Model.availableContacts[i].id) === -1) {
        insurance.idContacts.push($scope.Model.availableContacts[i].id);
      }
    }
    const idInsurances = _.uniq(_.map($scope.Model.currentTicket.insurances, 'id'));
    if (idInsurances.indexOf(insurance.idReference) === -1) {
      insurance.idReference = insurance.id;
      $scope.Model.currentTicket.insurances.push(Insurance.build(insurance));
      contactsService.clearCache();
      $scope.saveInsurances($scope.Model.currentTicket.insurances);
    } else {
      uiService.toast({
        text: {
          p1: 'Insurance',
          p2: insurance.getName(),
          p3: 'has already been added'
        },
        warn: true
      });
    }
  };

  $scope.saveInsurances = _.debounce((insurances) => {
    $scope.saveTicket({ insurances });
  }, 1500);

  /*
   * Risk insurance ~ Other advisers
   * --------------------------------------------------------------------------------
   */
  $scope.getOtherAdviserTypes = () => {
    $scope.Model.availableOtherAdviserTypes =
      otherAdvisersService.getAvailableOtherAdviserTypes({
        workflow: $scope.Model.currentWorkflow
      });
  };

  $scope.otherAdviserAdd = (otherAdviserType) => {
    otherAdvisersService.otherAdviserAdd(
      $scope.Model.currentTicket.otherAdvisers,
      otherAdviserType
    );
  };

  $scope.saveOtherAdvisers = _.debounce((otherAdvisers) => {
    $scope.saveTicket({ otherAdvisers });
  }, 1500);

  /*
   * Risk insurance ~ Insurance requirements
   * --------------------------------------------------------------------------------
   */
  $scope.saveRiskInsuranceRequirements = _.debounce((requirements) => {
    if (!_.isEmpty(requirements)) {
      $scope.Model.currentRiskInsurance.requirements = requirements;
      $scope.saveRiskInsurance({ requirements });
    }
  }, 500);

  /*
   * Risk insurance ~ Risk products
   * --------------------------------------------------------------------------------
   */
  $scope.riskInsuranceProductAdd = (productType) => {
    riskInsuranceService.riskInsuranceProductAdd(
      $scope.Model.currentRiskInsurance.products,
      productType
    );
  };

  $scope.saveRiskInsuranceProducts = _.debounce((products) => {
    if (products) {
      $scope.Model.currentRiskInsurance.products = products;
      $scope.saveRiskInsurance({ products });
    }
  }, 500);

  /*
   * Risk insurance ~ Compliance
   * --------------------------------------------------------------------------------
   */
  $scope.updateSectionsOfApplicants = () => {
    if ($scope.Model.availablePersonContacts?.length) {
      if (!$scope.Model.currentRiskInsurance?.requirements?.applicants) {
        $scope.Model.currentRiskInsurance.requirements.applicants = [];
      }
      if (!$scope.Model.currentRiskInsurance?.compliance?.verifications?.identities) {
        $scope.Model.currentRiskInsurance.compliance.verifications.identities = [];
      }
      const len = $scope.Model.availablePersonContacts?.length || 0;
      for (let a = 0; a < len; a += 1) {
        const applicant = $scope.Model.availablePersonContacts[a];
        const rIdx = _.findIndex(
          $scope.Model.currentRiskInsurance?.requirements?.applicants || [],
          (i) => i?.idContact === applicant?.id
        );
        if (rIdx === -1 && applicant?.id) {
          $scope.Model.currentRiskInsurance.requirements.applicants.push(
            RiskInsuranceRequirementsApplicant.blank(applicant.id)
          );
        }
        const vIdx = _.findIndex(
          $scope.Model.currentRiskInsurance?.compliance?.verifications?.identities || [],
          (i) => i?.idContact === applicant?.id
        );
        if (vIdx === -1 && applicant?.id) {
          $scope.Model.currentRiskInsurance.compliance.verifications.identities.push(
            VerificationsIdentity.blank(applicant.id)
          );
        }
      }
    }
    $scope.saveRiskInsurance({
      requirements: $scope.Model.currentRiskInsurance?.requirements,
      compliance: $scope.Model.currentRiskInsurance?.compliance
    });
  };

  $scope.updateRiskInsuranceCompliance = (data) => {
    if (!_.isEmpty(data?.compliance)) {
      $scope.Model.currentRiskInsurance.compliance = data.compliance;
    }
  };

  $scope.saveRiskInsuranceCompliance = (data) => {
    if (!_.isEmpty(data?.compliance)) {
      $scope.updateRiskInsuranceCompliance(data);
      $scope.saveRiskInsurance({
        compliance: $scope.Model.currentRiskInsurance.compliance,
        rICD: data?.rICD || ''
      });
    }
  };

  /*
   * Risk insurance ~ Diversifications
   * --------------------------------------------------------------------------------
   */
  $scope.saveDiversificationOpportunities = _.debounce((diversificationOpportunities) => {
    if (diversificationOpportunities !== undefined) {
      $scope.Model.currentTicket.diversificationOpportunities = diversificationOpportunities;
      $scope.saveTicket({ diversificationOpportunities });
    }
  }, 1500);

  $scope.saveTicketDiversificationOpportunitiesComments = _.debounce(
    (diversificationOpportunitiesComments) => {
      if (diversificationOpportunitiesComments) {
        $scope.Model.currentTicket.diversificationOpportunitiesComments =
          diversificationOpportunitiesComments;
      }
      $scope.saveTicket({
        diversificationOpportunitiesComments:
          $scope.Model.currentTicket.diversificationOpportunitiesComments
      });
    },
    1500
  );

  /*
   * Risk insurance ~ Back
   * --------------------------------------------------------------------------------
   */
  $scope.back = () => {
    $state.transitionTo('deal', { id: $stateParams.id, dd: $stateParams.dd });
  };

  /*
   * Risk insurance ~ Save Contact
   * --------------------------------------------------------------------------------
   */
  $scope.saveContact = _.debounce((contact) => {
    $scope.getAllAddresses();
    if (contact.getName() !== 'N/A') {
      contactService.updateContact(contact).then((data) => {
        contactsService.clearCache();
        if (data.status) {
          uiService.toast({
            text: {
              p1: 'Contact',
              p2: contact.getName(),
              p3: 'has been updated'
            },
            warn: false
          });
        }
      });
    } else {
      uiService.toast({
        text: {
          p1: 'Contact',
          p2: contact.isCompany ? 'Name' : 'First name and family name',
          p3: contact.isCompany ? 'is required' : 'are required'
        },
        warn: true
      });
    }
  }, 1500);

  /*
   * Risk insurance ~ Save Ticket
   * --------------------------------------------------------------------------------
   */
  $scope.saveTicket = (data) => {
    const ticket = data;
    const dataType = data?.dataType || '';
    $scope.Model.changedData = '';
    if (data?.dataType !== undefined) {
      delete ticket.dataType;
    }
    $scope.getAllAddresses();
    ticket.id = $scope.Model.currentTicket.id;
    ticket.name = $scope.Model.currentTicket.name;
    ticketService.updateTicket(ticket).then((result) => {
      ticketsService.clearCache();
      if (result.status) {
        $scope.Model.changedData = dataType;
        uiService.toast({
          text: {
            p1: 'Deal',
            p2: $scope.Model.currentTicket.getName(),
            p3: 'has been updated'
          },
          warn: false
        });
      }
    });
  };

  /*
   * Risk insurance ~ Save Risk insurance
   * --------------------------------------------------------------------------------
   */
  $scope.saveRiskInsurance = (data) => {
    const riskInsurance = data;
    const rICD = data?.rICD || '';
    if (data?.rICD !== undefined) {
      delete riskInsurance.rICD;
    }
    if (!$scope.Model.currentTicket?.isSettled) {
      riskInsurance.id = $scope.Model.currentRiskInsurance.id;
      if (!riskInsurance.id) {
        riskInsuranceService.createRiskInsurance(riskInsurance).then((result) => {
          if (result.status) {
            $scope.Model.currentRiskInsurance.id = result.id;
            $scope.Model.currentTicket.idRiskInsurance = result.id;
            $scope.saveTicket({ idLoan: $scope.Model.currentTicket.idRiskInsurance });
            uiService.toast({
              text: {
                p1: 'Risk insurance for deal',
                p2: $scope.Model.currentTicket.getName(),
                p3: 'has been created'
              },
              success: true
            });
          }
        });
      } else {
        riskInsuranceService.updateRiskInsurance(data).then((result) => {
          if (result.status) {
            uiService.toast({
              text: {
                p1: 'Risk insurance for deal',
                p2: $scope.Model.currentTicket.getName(),
                p3: 'has been updated'
              },
              success: true
            });
          }
          eventService.changedData({ changedData: rICD });
        });
      }
    }
  };
};
